import { ButtonProps } from '@bamboohr/fabric';

export interface EmergencyBlankStateProps {
    onClick: ButtonProps['onClick'];
    canAdd: boolean;
}

export const EMERGENCY_CONTACT_BLANK_TITLE = $.__('No emergency contacts have been added for this employee.');
export const ADD_CONTACT = $.__('Add Contact');
